import React from "react";
import { TextField } from '@mui/material';
import ModalWrapper from '../Modal/modalWrapper/basicModalWrapper';
import { cloneTestRunApiCall } from "../../utils/api";
const CloneTestRunModel = ({ isOpen, onClose, onError, onClone, title=DEFAULT_TITLE, data={} }) => {
    const { testCycleName='Test Run', id=null } = data;
    const handleConfirmClone = async (data='') => {
      try{
        const response = await cloneTestRunApiCall({
            testRunId: id,
            data: data,
        })

        if(response?.status>0){
            onClone();
            onClose();
        } else {
            onError(response?.error, 'error');
        }
      } catch (error) {
        console.error(`Error Cloning ${testCycleName}:`, error);
        onError(`Error Cloning ${testCycleName}`, 'error');
      }
    };
    
    const buttons = [
      {
        label: 'Cancel',
        variant: 'outline',
        className: 'primary',
        onClick: onClose,
      },
      {
        label: 'Clone',
        variant: 'primary',
        className: 'white bg-blue600',
      },
    ];
  
    const fields = [
      {
        Component: TextField,
        label: 'Name',
        name: 'name',
        required: true,
        autoFocus: true,
        fullWidth: true,
      },
      {
        Component: TextField,
        name: 'description',
        label: 'Description',
        multiline: true,
        rows: 3,
        autoFocus: false,
        fullWidth: true,
      },
      {
        Component: TextField,
        label: 'Start Date',
        name: 'startDate',
        required: true,
        type: 'date',
        fullWidth: true,
        InputLabelProps: { shrink: true }, 
      },
      {
        Component: TextField,
        label: 'End Date',
        name: 'endDate',
        required: true,
        type: 'date',
        fullWidth: true,
        InputLabelProps: { shrink: true }, // Ensures the label stays above the date field
        //defaultValue: '', 
      },
    ]
  
    return (
      <ModalWrapper
        open={isOpen}
        onClose={onClose}
        title={title}
        fields={fields}
        buttons={buttons}
        onSubmit={handleConfirmClone}
        containerStyles={{
          width: "450px"
        }}
        initialValues={{
          name: '',
          description: '',
          startDate: '',
          endDate: '',
        }}
      />
    );
  };
  
  export default CloneTestRunModel;